import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import resources from "./locales";

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        supportedLngs: ["en", "pl", "esp"],
        ...resources,
        lng: "en",
        fallbackLng: "en",
        interpolation: {
            escapeValue: false,
        },
    });

i18n.addResources("pl", "translation", resources.resources.pl);

export default i18n;
